import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@app/shared/shared.module';
import { PublicGuard } from '@app/auth/core/guards/public.guard';
import { AuthPrivateModule } from '@app/auth/private/auth-private.module';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginPageComponent } from './containers/login-page.component';
import { LoginService } from './services/login.service';
import { LoginEffects } from './state/login.effects';
import { reducer } from './state/login.reducer';
import { Verify2faCodeFormComponent } from '@app/auth/routes/login/components/verify-2fa-code/verify-2fa-code-form.component';
import { LoginComponent } from '@app/auth/routes/login/components/login/login.component';
import { VerifyViaRecoveryCodeComponent } from './components/verify-via-recovery-code/verify-via-recovery-code.component';

const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
    canActivate: [PublicGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    SharedModule,
    AuthPrivateModule,
    StoreModule.forFeature('authLogin', reducer),
    EffectsModule.forFeature([LoginEffects]),
  ],
  declarations: [
    LoginPageComponent,
    LoginComponent,
    LoginFormComponent,
    Verify2faCodeFormComponent,
    VerifyViaRecoveryCodeComponent,
  ],
  providers: [LoginService],
})
export class AuthLoginModule {}
